function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Elem from './Elem';
/**
 * An Elem wrapper only exposing root methods.
 * Extended by other primivite components to expose an initial set of methods.
 */

var RootElem =
/*#__PURE__*/
function () {
  /**
   * Creates a new RootElem instance
   * @param {string} tagName Tag name. Eg. 'div'.
   * @param {object} [opt] Optional parameters
   * @param {string} [opt.className] Class name
   * @param {object} [opt.attributes] Key/value object with attributes.
   * @param {object} [opt.events] Key/value object with events, where the key is the event name, and the value is the callback function.
   * @param {Array.<Elem~node>} [children] Array of child nodes
   */
  function RootElem(tagName, opt, children) {
    _classCallCheck(this, RootElem);

    this._rootElem = new Elem(function (n) {
      return n.elem(tagName, opt, children);
    });

    this._rootElem.setContext(this);
  }

  _createClass(RootElem, [{
    key: "render",
    value: function render(el) {
      return this._rootElem.render(el);
    }
  }, {
    key: "unrender",
    value: function unrender() {
      this._rootElem.unrender();
    }
  }, {
    key: "getElement",
    value: function getElement() {
      return this._rootElem.getElement();
    }
  }, {
    key: "setClassName",
    value: function setClassName(className) {
      this._rootElem.setClassName(className);

      return this;
    }
  }, {
    key: "addClass",
    value: function addClass(className) {
      this._rootElem.addClass(className);

      return this;
    }
  }, {
    key: "removeClass",
    value: function removeClass(className) {
      this._rootElem.removeClass(className);

      return this;
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(name, value) {
      this._rootElem.setAttribute(name, value);

      return this;
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(name) {
      this._rootElem.removeAttribute(name);

      return this;
    }
  }, {
    key: "setProperty",
    value: function setProperty(name, value) {
      this._rootElem.setProperty(name, value);

      return this;
    }
  }, {
    key: "getProperty",
    value: function getProperty(name) {
      return this._rootElem.getProperty(name);
    }
  }, {
    key: "setDisabled",
    value: function setDisabled(isDisabled) {
      this._rootElem.setDisabled(isDisabled);

      return this;
    }
  }, {
    key: "setEvent",
    value: function setEvent(name, callback) {
      this._rootElem.setEvent(name, callback);

      return this;
    }
  }, {
    key: "removeEvent",
    value: function removeEvent(name) {
      this._rootElem.removeEvent(name);

      return this;
    }
  }]);

  return RootElem;
}();

export default RootElem;